<template>
  <div class="oversee-box">
    <!-- 督办列表 -->
    <div class="datalist">
      <div v-for="(item, index) in dataList" :key="index" @click="detail(item)" class="data-item">
        <div class="item-left">
          <p class="title">{{ item.overseeOrgName }}的督办</p>
          <p class="time">发起时间：{{ item.createTime | timeFilter }}</p>
        </div>
        <!-- <div class="item-right" :class="{'yellow': item.state === 'WAIT_REVOER', 'greentxt': item.state === 'REVOERED'}">{{ overseeStatus(item.state) }}</div> -->
        <div class="item-right yellow" v-if="item.state !== 'REVOERED' ">待反馈</div>
        <div class="item-right greentxt" v-else>已反馈</div>
      </div>
    </div>
  </div>
</template>

<script>
    import api from '../../../../service/modules/refund';
    import util from '../../../../utils/common'

    export default {
        filters: {
            timeFilter (val) {
                return util.getStampInDate3(val)
            }
        },
        data () {
            return {
                dataList: [],
                flowId: '',
                userInfo: {}

            };
        },
        created () {
            try {
                this.userInfo = this.$store.state.refund.userInfo
                this.flowId = JSON.parse(this.$route.query.data).flowId;
                this.getData();
            } catch (err) {
            }
        },
        methods: {
            // 查看督办详情
            detail (item) {
                this.$router.push({
                    path: '/refund/oversee',
                    query: {
                        detail: JSON.stringify(item),
                        flowId: this.flowId
                    }
                });
            },
            // 督办状态
            overseeStatus (val) {
                const option = {
                    'WAIT_REVOER': '待反馈',
                    'REVOERED': '已反馈'
                }
                return option[val]
            },
            // 获取退货单详情
            getData () {
                try {
                    api.detailList({ flowId: this.flowId }).then(res => {
                        if (res.ret === 0) {
                            this.dataList = res.data.refundOverSeeList;
                            this.dataList.sort((a, b) => {
                              return b.createTime - a.createTime
                            })
                        }
                    });
                } catch (err) {
                    alert(err)
                }
            }
        }
    };
</script>

<style lang="less" scoped>
.oversee-box {
  padding: 12px 12px;
  min-height: 100vh;
  background-color: #f8f9fc;
  .datalist {
    .data-item {
      padding: 16px;
      background-color: white;
      display: flex;
      justify-content: space-between;
      .item-left {
        .title {
          font-size: 16px;
          color: #333333;
          font-weight: 500;
        }
        .time {
          font-size: 14px;
          color: #999999;
          font-weight: 400;
          line-height: 24px;
        }
      }
      .item-right {
        font-size: 14px;
        color: #36b374;
        font-weight: 400;
      }
      .greentxt {
        color: #36B374;
      }
      .yellow {
        color: #FF8C19;
      }
    }
  }
}
</style>
